import { useDroppable, type UseDroppableArguments } from "@dnd-kit/core";
import clsx from "clsx";

export const Droppable: React.FC<
  React.PropsWithChildren<UseDroppableArguments>
> = ({ children, ...props }) => {
  const { isOver, setNodeRef } = useDroppable(props);
  return (
    <div
      ref={setNodeRef}
      className={clsx(
        "flex flex-col divide-y-2 overflow-auto rounded border transition-colors",
        isOver ? "bg-base-200" : "bg-base-100",
        props.disabled
          ? "divide-accent border-accent ring-1 ring-accent"
          : "shadow-inner",
      )}
    >
      {children}
    </div>
  );
};
